// The immersive reader page. Shared by static#paper (the public paper) and
// papers#version (one version of your own paper) — both set
// `@page_name = "Paper"` and render papers/_paper_reader.
import { registerPage } from "../first"
import { loadBundle } from "../lazy"

// pdf.js is fetched here rather than bundled into application.js: this is one
// of the two pages that renders a PDF, and it is the only thing on it, so the
// wait is the page's own work rather than a tax on every other page.
export const PaperPage = {
  onDomReady(): void {
    void loadBundle<{ mountPaperReaders: () => void }>("pdf-reader")
      .then((module) => module.mountPaperReaders())
      .catch(() => {
        // Nothing to fall back to — the reader IS the page — so say so where
        // the pages would have gone.
        document.querySelectorAll<HTMLElement>("[data-paper-reader], [data-pdf-viewer]").forEach((host) => {
          host.textContent = "Could not load the PDF reader. Reload the page to try again."
        })
      })
  },
}

registerPage("PaperPage", PaperPage)
